const normalizePlayerId = (value) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return `${value}`;
  if (!value || typeof value !== 'object') return '';

  const candidate = value.id || value._id || value.playerId || value.player || value.value;
  if (candidate && candidate !== value) return normalizePlayerId(candidate);
  return '';
};

const normalizeWicketType = (value) => String(value || '').trim().toLowerCase().replace(/_/g, '-');

const isDismissalEvent = (event) => (
  Boolean(event?.isWicket) && normalizeWicketType(event?.wicketType) !== 'retired-hurt'
);

const getDismissedPlayerIdFromEvent = (event = {}) => {
  const explicitDismissedPlayer = normalizePlayerId(
    event.outPlayerId ||
    event.wicketPlayerId ||
    event.outPlayer ||
    event.playerOutId ||
    event.batterOutId
  );
  if (explicitDismissedPlayer) return explicitDismissedPlayer;

  const isRunOut = normalizeWicketType(event.wicketType) === 'run-out';
  if (isRunOut) {
    const runOutWho = String(event.runOutWho || '').trim().toLowerCase();
    if (runOutWho === 'non-striker' || event.isStriker === false) {
      return normalizePlayerId(event.nonStrikerId || event.nonStriker);
    }
  }

  return normalizePlayerId(event.strikerId || event.striker);
};

export const buildDismissedPlayerIds = (score = {}) => {
  const currentInnings = Number(score?.currentInnings) || 1;
  const dismissedPlayerIds = new Set();

  (Array.isArray(score?.events) ? score.events : []).forEach((event) => {
    const eventInnings = Number(event?.inningsNumber);
    if (Number.isFinite(eventInnings) && eventInnings > 0 && eventInnings !== currentInnings) return;
    if (!isDismissalEvent(event)) return;

    const dismissedPlayerId = getDismissedPlayerIdFromEvent(event);
    if (dismissedPlayerId) dismissedPlayerIds.add(dismissedPlayerId);
  });

  return dismissedPlayerIds;
};

export const buildBatterDropdownOptions = ({
  allBattingPlayers = [],
  dismissedPlayerIds = new Set(),
  striker = '',
  nonStriker = '',
} = {}) => {
  const strikerId = normalizePlayerId(striker);
  const nonStrikerId = normalizePlayerId(nonStriker);
  const availableBattingPlayers = (Array.isArray(allBattingPlayers) ? allBattingPlayers : [])
    .filter((player) => !dismissedPlayerIds.has(normalizePlayerId(player)));

  return {
    strikerOptions: availableBattingPlayers.filter((player) => normalizePlayerId(player) !== nonStrikerId),
    nonStrikerOptions: availableBattingPlayers.filter((player) => normalizePlayerId(player) !== strikerId),
  };
};
